/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC, useCallback, useState } from "react";
import { BEM } from "@adapptio/lib-components";
import { ReadmeEditorView } from "../ReadmeEditorView";
import { useSimpleEvent } from "../../../../ui/hooks/useSimpleEvent";
import { BlueprintEditor } from "../../../../ui/components/BlueprintEditor/BlueprintEditor";
import { Panel, PANEL_STYLE } from "../../../../ui/components/Panel";

export interface IReadmeEditorDebugProps {
	view: ReadmeEditorView;
}

export const ReadmeEditorDebug: FC<IReadmeEditorDebugProps> = ({ view }) => {
	const model = view.getModel();
	const [ content, setContent ] = useState(() => model.exportDocumentAsYAML());

	useSimpleEvent(
		model.onModelChange,
		() => {
			setContent(model.exportDocumentAsYAML());
		},
		[ model ]
	);

	const handleApplyChanges = useCallback(
		async (newContent: string) => {
			await model.loadDocument(newContent);
		},
		[ model ]
	);

	const baseClass = BEM("edt-readme-debug-mode");

	return (
		<Panel style={PANEL_STYLE.NONE} scroll={false} className={baseClass.toClassName()}>
			<BlueprintEditor
				initialValue={content}
				onApplyChanges={handleApplyChanges}
			/>
		</Panel>
	);
};
